import { APPLICATION_TRUST_STATUS } from 'src/utils/enums/applicationTrustStatus';

export const CATALOG_DRIFT_MESSAGE =
  'Files have been detected for this app since its App Import Catalog entry was last updated — update it to cover them.';

// trustUpdatedOn moves whenever the app is trusted, including when its artifacts are rebuilt, so
// anything newer than it is activity nobody has acted on yet.
export const getCatalogWarning = row =>
  row?.status === APPLICATION_TRUST_STATUS.Trusted &&
  row?.eventSystemTime &&
  row?.trustUpdatedOn &&
  new Date(row.eventSystemTime) > new Date(row.trustUpdatedOn)
    ? CATALOG_DRIFT_MESSAGE
    : null;
